import { Directive, inject } from '@angular/core';

import { injectFlags } from '@shared/services/launch-darkly.service';

import { SearchModalService } from '../services/search-modal.service';

@Directive({
  host: {
    '(window:keydown)': 'handleKeyDown($event)',
  },
  selector: '[auxSearchShortcut]',
})
export class SearchShortcutDirective {
  searchModalService = inject(SearchModalService);

  flags = injectFlags({
    showSearchBar: 'nav_search_bar',
  });

  handleKeyDown = (event: KeyboardEvent) => {
    // Only handle shortcuts if the search bar feature is enabled
    if (!this.flags().showSearchBar) {
      return;
    }

    // Cmd+K on Mac or Ctrl+K on Windows/Linux
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      event.stopPropagation();
      this.searchModalService.openSearchModal();
    }
  };
}
